import React from 'react';
import { useId, useConst } from '@fluentui/react-hooks';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import { Edit20Regular } from '@fluentui/react-icons';
import { Button } from '@fluentui/react-components';
import PropTypes from 'prop-types';

const WrappedButton = ({ useNewEditorIcon, ...restProps }) => (useNewEditorIcon ?
  (<Button
    {...restProps}
    icon={<Edit20Regular />}
  />) :
  (<button
    {...restProps}
  />));

WrappedButton.propTypes = {
  useNewEditorIcon: PropTypes.bool.isRequired,
};

export const EditableImageButton = (props) => {
  const {
    imageItem, i18n, baseImageId, onEdit, useNewEditorIcon,
  } = props;
  const tooltipId = useId('disableEditImageToolTip');
  const buttonId = useId('targetButton');
  const calloutProps = useConst({
    gapSpace: 0,
    target: `#${buttonId}`,
  });

  return (
    <React.Fragment>
      {
        !imageItem.disableEdit && <WrappedButton
          aria-label={i18n.getString(_TL_('Edit Image'))}
          className={useNewEditorIcon ? 'image-edit' : 'glyphicon glyphicon-pencil image-edit'}
          onClick={onEdit}
          data-imageid={baseImageId}
          useNewEditorIcon={useNewEditorIcon}
        />
      }
      {
        imageItem.disableEdit &&
          <TooltipHost
            content={i18n.getString(_TL_('We don’t allow you to edit system-generated images.'))}
            id={tooltipId}
            calloutProps={calloutProps}
          >
            <WrappedButton
              id={buttonId}
              aria-label={i18n.getString(_TL_('Edit Image'))}
              aria-describedby={tooltipId}
              className={useNewEditorIcon ? 'image-edit is-recommended-image' : 'glyphicon glyphicon-pencil image-edit is-recommended-image'}
              useNewEditorIcon={useNewEditorIcon}
            />
          </TooltipHost>
      }
    </React.Fragment>
  );
};

EditableImageButton.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  baseImageId: PropTypes.string.isRequired,
  imageItem: PropTypes.shape({
    disableEdit: PropTypes.bool.isRequired,
  }).isRequired,
  useNewEditorIcon: PropTypes.bool,
};

EditableImageButton.defaultProps = {
  useNewEditorIcon: false,
};

